import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemeService } from '../theme/ThemeService';

@Component({
    selector: 'popup-header',
    template: `
        <div [ngClass]="toolbarClass" class="md-toolbar-tools">
            <mat-icon *ngIf="titleIcon" [svgIcon]="titleIcon"></mat-icon>
            <mat-icon *ngIf="materialTitleIcon">{{materialTitleIcon}}</mat-icon>
            <span>{{ text }}</span>
            <div fxFlex></div>
            <cas-button
                *ngIf="showIcon && icon"
                [color]="null"
                [materialIcon]="icon"
                (clickAction)="onClick()"
                [iconButton]="true"
            >
            </cas-button>
            <cas-button
                *ngIf="showIcon && !icon"
                [color]="null"
                materialIcon="cancel"
                (clickAction)="onClick()"
                [iconButton]="true"
            >
            </cas-button>
        </div>
    `,
    styles: [`
        span {
            padding: 0 16px 0 16px;
        }
    `]
})
export class PopupHeaderComponent implements OnInit {
    @Input() text: string;
    @Input() titleIcon: string;
    @Input() materialTitleIcon: string;
    @Input() icon: string;
    @Input() showIcon = true;
    @Output() clickAction: EventEmitter<any> = new EventEmitter();

    toolbarClass: string;

    constructor(
        private themeService: ThemeService
    ) {
    }

    public ngOnInit() {
        this.toolbarClass = this.themeService.getBackgroundPrimaryClassHue2();
    }

    public onClick() {
        this.clickAction.emit();
    }
}
